import React from "react";
import { Link } from "react-router-dom";
import Icon from "components/AppIcon";

export default function BrandHeader() {
  return (
    <div className="text-center mb-8">
      <Link to="/landing-page" className="inline-flex items-center gap-3 group">
        <div className="w-12 h-12 rounded-xl bg-primary flex items-center justify-center shadow-lg group-hover:scale-105 transition-transform duration-200">
          <Icon name="Zap" size={24} color="#FFFFFF" strokeWidth={2.5} />
        </div>
        <span className="text-2xl font-bold text-white font-heading">
          Fit<span className="text-teal-400">Pulse</span>
        </span>
      </Link>
      <p className="mt-2 text-slate-500 text-xs font-caption">GymVendorDash — Gym Management Platform</p>
    </div>
  );
}
